import Image from 'next/image'
import { useEffect } from 'react'

import { STATIC_IMAGE_BASE } from '@mc/constants'
import { Button, Modal, ModalClose, ModalContent } from '@mc/design-system'
import { useTranslation } from '@mc/i18n'

import { trackModalClicked } from '../../events/modalClicked'
import { Location, trackModalViewed } from '../../events/modalViewed'
import { PERSONA_IN_TIERS_I18N_NAMESPACE } from '../../i18n'
import { OnCallLogo } from './OnCallLogo'

export const ExplainerModal = ({
  show,
  onClose,
  location,
}: {
  show: boolean
  onClose: () => void
  location: Location
}) => {
  const { t } = useTranslation(PERSONA_IN_TIERS_I18N_NAMESPACE)

  useEffect(() => {
    if (show) trackModalViewed({ location })
  }, [location, show])

  const handleCtaClick = () => {
    trackModalClicked({ action: t('modal.cta') })
    onClose()
  }

  const handleCloseClick = () => {
    trackModalClicked({ action: 'x' })
    onClose()
  }

  return (
    <Modal size='medium' show={show} onClose={handleCloseClick}>
      <ModalContent className='mc-invert mc-text-color--dark mc-corners--md mc-overflow--hidden'>
        <ModalClose style={{ color: 'var(--mc-color-icon-tint-dark)' }} />
        <div className='mc-theme-light mc-bg-light d-flex flex-column mc-text--center'>
          <ModalImage />
          <div className='mc-p-8'>
            <OnCallLogo
              className='mc-mb-4'
              style={{ width: '148px' }}
              aria-label={t('modal.a11y.onCallLogo')}
            />

            <h1 className='mc-text-h2 mc-mb-2'>{t('modal.title')}</h1>

            <p className='mc-text-color--neutral-600 mc-mb-4'>
              {t('modal.description')}
            </p>

            <p className='mc-text-color--neutral-600 mc-mb-4'>
              {t('modal.disclaimer')}
            </p>

            <Button kind='secondary' fullWidth onClick={handleCtaClick}>
              {t('modal.cta')}
            </Button>
          </div>
        </div>
      </ModalContent>
    </Modal>
  )
}

const ModalImage = () => (
  <>
    <div className='d-none d-md-flex'>
      <Image
        className='position-relative'
        alt=''
        src={`${STATIC_IMAGE_BASE}/prcng_472_v4_persona_in_tiers_modal.png`}
        objectFit='cover'
        objectPosition='top'
        fill
      />
    </div>
    <div className='flex d-flex d-md-none'>
      <Image
        className='position-relative'
        alt=''
        src={`${STATIC_IMAGE_BASE}/prcng_472_v4_persona_in_tiers_modal_mobile.png`}
        objectFit='cover'
        objectPosition='top'
        fill
      />
    </div>
  </>
)
